import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Popover, { ArrowContainer } from "react-tiny-popover";
import BootstrapColors from "../../../Services/Shared/BootstrapColor.service";
import useSupportsHover from "../../Hooks/useSupportsHover";
import useIsElementHovered from "../../Hooks/useIsElementHovered";
const TRANSITION_DURATION_MS = 500;
const getPositionOpposite = (position) => {
    switch (position) {
        case "left":
            return "right";
        case "right":
            return "left";
        case "top":
            return "bottom";
        case "bottom":
            return "top";
        default:
            return "";
    }
};
const defaultConfig = {
    maintainDelay: 500,
    position: ["right", "left", "bottom", "top"],
    popoverZIndex: 99999,
    popoverMaxWidth: 300,
    popoverPadding: 3,
};
/**
 * Opinionated styling and behavior of a popover element.  This configure is designed to create a popover with minimal configuration.
 */
const DefaultPopover = (props) => {
    const config = Object.assign(Object.assign({}, defaultConfig), props.config);
    const [isPopoverHovered, setIsPopoverHovered] = React.useState(null);
    const [childProps, isChildHovered] = useIsElementHovered();
    const [maintainStatus, setMaintainStatus] = React.useState(false);
    React.useEffect(() => {
        let timeout;
        if (isChildHovered === false && props.popoverBehavior === "maintain") {
            setMaintainStatus(true);
            timeout = setTimeout(() => {
                setMaintainStatus(false);
            }, config.maintainDelay);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [config.maintainDelay, isChildHovered, props.popoverBehavior]);
    const popoverIsOpen = React.useMemo(() => {
        switch (props.popoverBehavior) {
            case "manual":
                return props.isOpen;
            case "hover":
                return isChildHovered;
            case "maintain":
                return isChildHovered || isPopoverHovered || maintainStatus;
            default:
                return false;
        }
    }, [
        isChildHovered,
        isPopoverHovered,
        maintainStatus,
        props.isOpen,
        props.popoverBehavior,
    ]);
    const supportsHover = useSupportsHover();
    // There's a bug with the popover where it stays around after we hide it and prevents the user from making selections
    // underneath where it once was.  Therefore, we maintain a separate state variable for whether we should render
    // this at all, and update it with a slight delay when we hide the popover so that the animations still work
    // we also won't display this on devices that don't support hover, because it messes with onClick events because
    // we get a onMouseEnter, onClick, and then onMouseLeave in quick succession
    const [renderPopover, setRenderPopover] = React.useState(true);
    React.useEffect(() => {
        let timeout;
        if (popoverIsOpen) {
            setRenderPopover(true);
        }
        else {
            timeout = setTimeout(() => {
                setRenderPopover(false);
            }, TRANSITION_DURATION_MS);
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [popoverIsOpen]);
    const content = props.children({
        popoverProps: childProps,
    });
    return renderPopover && supportsHover ? (_jsx(Popover, { isOpen: popoverIsOpen !== null && popoverIsOpen !== void 0 ? popoverIsOpen : false, position: config.position, transitionDuration: config.transitionDuration
            ? config.transitionDuration / 1000
            : TRANSITION_DURATION_MS / 1000, padding: 15, containerStyle: {
            zIndex: "99999",
        }, content: ({ position, targetRect, popoverRect }) => (_jsx(ArrowContainer, { position: position, targetRect: targetRect, popoverRect: popoverRect, arrowColor: BootstrapColors.Primary, children: _jsx("div", { onMouseEnter: () => setIsPopoverHovered(true), onMouseLeave: () => {
                    setIsPopoverHovered(false);
                    setMaintainStatus(false);
                }, className: `bg-light border p-${config.popoverPadding} rounded m${getPositionOpposite(position)[0]}-0`, style: {
                    zIndex: config.popoverZIndex,
                    boxShadow: "rgba(0, 0, 0, 0.25) 0px 4px 4px 0px",
                    // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'MaxWidth<string | number> | undefined'.
                    maxWidth: config.popoverMaxWidth,
                    margin: "5px",
                    opacity: 0.95,
                }, children: props.popoverContent }) })), children: content })) : (content);
};
export default DefaultPopover;
